import { ActionsOfType } from 'affiny-core/modules/helpers';
import {
  ESpecialOfferActionType,
  TSpecialOfferAction,
} from 'affiny-core/modules/specialOffer/actions';
import { all, call, takeLatest } from 'redux-saga/effects';

function* redirectToSoPaymentPage(
  action: ActionsOfType<
    TSpecialOfferAction,
    ESpecialOfferActionType.REDIRECT_TO_SO_PAYMENT_PAGE
  >
) {
  yield call(window.open, action.payload.paymentSoUrl, '_self');
}

export function* redirectSpecialOfferSaga() {
  yield all([
    takeLatest(
      ESpecialOfferActionType.REDIRECT_TO_SO_PAYMENT_PAGE,
      redirectToSoPaymentPage
    ),
  ]);
}
